import _ from 'lodash'
import * as types from './mutation-types'
import {parseDate} from '@/assets/func'

export default {
  [types.SET_USER_INFO] (state, userInfo) { // --> use --> login
    state.loginStatus = userInfo.data.status
    if (userInfo.data.status === -1) return
    let info = {
      uid: userInfo.uid,
      cust_knd: userInfo.data.cust_knd,
      cust_nm: userInfo.data.cust_nm
    }
    let user = btoa(encodeURIComponent(JSON.stringify(info)))
    sessionStorage.setItem('iw_u', user)
  },
  setLoginStatus (state, num) { // --> use --> login
    state.loginStatus = num
  },
  [types.SET_CAMPAIGN_LIST] (state, {list}) { // --> use --> app
    state.campaignList_0 = list.data
    state.getStatus = list.status

    let res = {
      campaignList_1: [],
      campaignList_2: [],
      campaignList_3: [],
      campaignList_4: [],
      campaignList_5: []
    }
    list.data.forEach(function (campaign) {
      let dt = new Date()
      switch (campaign.status) {
        case '1':
          res.campaignList_1.push(campaign)
          break
        case '2':
          res.campaignList_2.push(campaign)
          break
        case '3':
          res.campaignList_3.push(campaign)
          break
        case '4':
          let toYmd = parseDate(campaign.campaign_to_ymd)
          let n = parseInt(dt - toYmd) / 86400000
          if (n <= 7) {
            res.campaignList_2.push(campaign)
          }
          res.campaignList_4.push(campaign)
          break
        case '5':
          res.campaignList_5.push(campaign)
          break
        default: break
      }
    })
    for (let i = 1; i <= 5; i++) {
      state['campaignList_' + i] = res['campaignList_' + i]
    }
  },
  clearCampaignList (state) {
    state.campaignList_0 = []
    state.campaignList_1 = []
    state.campaignList_2 = []
    state.campaignList_3 = []
    state.campaignList_4 = []
    state.campaignList_5 = []
    state.campaignListStatus = '2'
    state.campaignInfo = {}
    state.getStatus = false
    state.searchKey = ''
    state.listOrderType = 'desc'
    state.listSortKey = 'campaign_fr_ymd'
  },
  [types.SET_DASHBOARD_DATA] (state, {data}) { // --> use --> dashboard
    state.dashboardData.top = data[0]
    state.dashboardData.bottom = data[1]
  },
  setCurrentPageNum (state, pNum) { // --> use --> resultList
    state.currentPage = pNum
  },
  setSortKey (state, key) { // --> use --> resultList
    state.listSortKey = key
  },
  setOrderType (state, type) { // --> use --> resultList
    state.listOrderType = type
  },
  setListStatus (state, value) { // --> use --> resultList
    state.campaignListStatus = value
  },
  setSearchKey (state, keyword) { // --> use --> resultList
    state.searchKey = keyword
  },
  sortCampaignList (state) { // --> use --> resultList
    let sortKey = state.listSortKey
    let orderType = state.listOrderType
    let status = state.campaignListStatus
    let searchKey = state.searchKey
    let checkKey = ['campaign_nm', 'agency_nm', 'client_nm', 'lab_cust_nm']
    let data = state['campaignList_' + status].slice()
    if (data.length === 0) {
      state.searchList = {data: [], info: 0}
      return
    }

    if (sortKey) {
      data = _.orderBy(data, sortKey, orderType)
    }
    if (searchKey) {
      data = data.filter(function (campaign) {
        return Object.keys(campaign).some(function (key) {
          if (checkKey.indexOf(key) < 0) {
            return false
          }
          return String(campaign[key]).toLowerCase().indexOf(searchKey) > -1
        })
      })
    }

    state.searchList.data = data
    state.searchList.info = data.length
  },
  setOpenGangnam (state) {
    state.isViewGangnam = true
  },
  setCloseGangnam (state) {
    state.isViewGangnam = false
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js